import React, { useState, useEffect, useCallback } from 'react';
import VerdictCard from './VerdictCard';
import FilterBar from './FilterBar';
import { fetchReviews } from './realTalkApi';

export default function VerdictGrid() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [total, setTotal] = useState(0);
  const [filters, setFilters] = useState({ college: '', course: '', minRating: '' });
  const [tab, setTab] = useState('all'); // all | written | voice | verified

  const loadReviews = useCallback(async (pageNum = 1, append = false) => {
    if (pageNum === 1) setLoading(true); else setLoadingMore(true);
    try {
      const data = await fetchReviews({
        college: filters.college, course: filters.course, minRating: filters.minRating,
        reviewType: tab === 'written' || tab === 'voice' ? tab : undefined,
        verifiedOnly: tab === 'verified',
        page: pageNum, limit: 12,
      });
      if (append) setReviews((prev) => [...prev, ...data.reviews]); else setReviews(data.reviews);
      setTotal(data.total);
      setHasMore(data.has_more);
      setPage(pageNum);
    } catch (err) { /* silent — UI shows empty-state fallback */ }
    finally { setLoading(false); setLoadingMore(false); }
  }, [filters, tab]);

  useEffect(() => { loadReviews(1, false); }, [loadReviews]);
  const handleFilterChange = (newFilters) => { setFilters(newFilters); };
  const handleLoadMore = () => { loadReviews(page + 1, true); };

  const TABS = [
    { id: 'all', label: 'All Reviews' },
    { id: 'written', label: 'Written' },
    { id: 'voice', label: 'Voice' },
    { id: 'verified', label: 'Verified' },
  ];

  return (
    <section className="rt-verdicts-section" data-testid="rt-verdicts-section">
      <div className="rt-verdicts-container">
        <div className="rt-verdicts-header">
          <h2 className="rt-verdicts-title">Latest Campus Truth</h2>
          {total > 0 && <span className="rt-verdicts-count">{total} verdict{total !== 1 ? 's' : ''}</span>}
        </div>
        <div className="rt-tabs" role="tablist" data-testid="ct-tabs">
          {TABS.map((t) => (
            <button
              key={t.id}
              role="tab"
              aria-selected={tab === t.id}
              onClick={() => setTab(t.id)}
              data-testid={`ct-tab-${t.id}`}
              className={`rt-tab ${tab === t.id ? 'rt-tab-active' : ''}`}
            >
              {t.label}
            </button>
          ))}
        </div>
        <FilterBar filters={filters} onFilterChange={handleFilterChange} />
        {loading && (<div className="rt-loading" data-testid="rt-loading"><div className="rt-loading-spinner" /><p>Loading student experiences...</p></div>)}
        {!loading && reviews.length === 0 && (
          <div className="rt-empty-state" data-testid="rt-empty-state">
            <div className="rt-empty-icon">📝</div>
            <h3>No verified student experiences have been published for this filter yet.</h3>
            <p>Are you studying here? Be the first to help future students make a better decision.</p>
          </div>
        )}
        {!loading && reviews.length > 0 && (
          <>
            <div className="rt-card-grid">{reviews.map((review) => (<VerdictCard key={review.review_id} review={review} />))}</div>
            {hasMore && (
              <div className="rt-load-more">
                <button onClick={handleLoadMore} disabled={loadingMore} className="rt-load-more-btn" data-testid="rt-load-more">
                  {loadingMore ? (<span className="rt-spinner-wrap"><span className="rt-spinner" /> Loading...</span>) : 'Load More Verdicts'}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
}
